export default __webpack_public_path__ + "static/media/IconMeActive.ef940ee7.svg";